import { Component } from 'react'
import { connect } from 'react-redux'
import WPAPI from 'wpapi'
import PropTypes from 'prop-types'
import { updateContent } from 'store/content'
import { toggleBlockUI } from 'store/blockUI'
import { rootPath } from 'lib/Utils'

const wp = new WPAPI({ endpoint: `${rootPath}/wp-json` })

class News extends Component {
  constructor (props) {
    super(props)
    this.proceedWithPromise = this.proceedWithPromise.bind(this)
  }

  componentDidMount () {
    this.doAjaxRequest()
  }

  componentDidUpdate () {
    this.doAjaxRequest()
  }

  doAjaxRequest () {
    this.props.toggleBlockUI(true)
    let promise
    this.contentObject = { type: 'postsArchive', 'title': 'News' }

    // Do an ajax requesto to WP API in order to get
    // the posts and the categories
    if (this.props.route.path === 'news/category/:slug') {
      wp.categories().slug(this.props.params.slug)
        .then((data) => {
          // this.contentObject.type = 'postsArchiveCategory' // s
          promise = wp.posts().categories(data[0].id).perPage(100).embed()
          this.proceedWithPromise(promise)
        })
    } else {
      promise = wp.posts().perPage(100).embed()
      this.proceedWithPromise(promise)
    }
  }

  proceedWithPromise (promise) {
    promise
      .then((data) => {
        this.contentObject.items = data
        return wp.categories()
      })
      .then((data) => {
        this.contentObject.categories = data
        this.props.updateContent(this.contentObject)
        this.props.toggleBlockUI(false)
      })
      .catch((error) => {
        console.warn(error)
        this.props.toggleBlockUI(false)
      })
  }

  render () {
    return null
  }
}

const mapDispatchToProps = {
  updateContent: (content) => updateContent(content),
  toggleBlockUI: (block) => toggleBlockUI(block)
}

News.propTypes = {
  updateContent: PropTypes.func,
  toggleBlockUI: PropTypes.func,
}

export default connect(null, mapDispatchToProps)(News)



// WEBPACK FOOTER //
// ./src/routes/News/index.js